import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'App';
import { createBonusMalus } from 'api/bonusMalusApi';
import classNames from 'classnames';
import React, { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import { capitalize } from 'helpers/utils';

const CreateBonusMalusModal = ({
  scoreType,
  playerType,
  modalShow,
  setModalShow
}) => {
  const [formData, setFormData] = useState({
    name: '',
    type: scoreType,
    points: scoreType === 'bonus' ? 20 : -20
  });

  const [checkState, setCheckState] = useState({
    S: playerType === 'students',
    T: playerType === 'teachers'
  });

  const [errors, setErrors] = useState({});

  const handleFieldChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleCheck = e => {
    const checked = e.target.checked;
    const name = e.target.name;
    setCheckState({
      ...checkState,
      [name]: checked
    });
  };

  const mutation = useMutation({
    mutationFn: createBonusMalus,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['studentsBonusMalusData']
      });

      queryClient.invalidateQueries({
        queryKey: ['teachersBonusMalusData']
      });

      setModalShow(false);
      setFormData({
        name: '',
        type: scoreType,
        points: scoreType === 'bonus' ? 20 : -20
      }); //reset the form to default values.

      toast.success(
        <span>
          {capitalize(scoreType)} <strong>{formData.name}</strong> creato ✅
        </span>
      );
    },
    onError: err => {
      toast.error(err.response?.data?.message || err.message);
    }
  });

  const handleSubmit = event => {
    event.preventDefault();
    const validForString =
      (checkState.S ? 'S' : '') + (checkState.T ? 'T' : '');
    if (validForString === '') {
      setErrors(prevErrors => ({
        ...prevErrors,
        valid_for: "Seleziona almeno un'opzione"
      }));
    } else {
      mutation.mutate({
        ...formData,
        valid_for: validForString
      });
    }
  };

  return (
    <>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter" className="fs-8">
            Crea un nuovo {formData.type}
          </Modal.Title>
        </Modal.Header>

        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <div className="p-2 flex-grow-1">
              <Form.Group className="mb-3">
                <Form.Label className="fs-9">Tipo</Form.Label>
                <Form.Select
                  value={formData.type}
                  name="type"
                  onChange={handleFieldChange}
                >
                  <option value="bonus">Bonus</option>
                  <option value="malus">Malus</option>
                </Form.Select>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label className="fs-9">
                  Nome del {formData.type}
                </Form.Label>
                <Form.Control
                  type="text"
                  value={formData.name}
                  onChange={handleFieldChange}
                  name="name"
                  maxLength={75}
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label className="fs-9">Punti</Form.Label>
                <Form.Control
                  type="number"
                  value={formData.points}
                  onChange={handleFieldChange}
                  name="points"
                  max={formData.type == 'bonus' ? 500 : 0}
                  min={formData.type == 'bonus' ? 1 : -500}
                  autoComplete="off"
                  required
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label className="fs-9">Valido per:</Form.Label>
                <div className="ms-2">
                  <Form.Check
                    type="checkbox"
                    label="Studenti"
                    name="S"
                    onChange={handleCheck}
                    checked={checkState['S']}
                  />
                  <Form.Check
                    type="checkbox"
                    label="Professori"
                    name="T"
                    onChange={handleCheck}
                    checked={checkState['T']}
                  />
                  <div
                    className={classNames('invalid-feedback', {
                      'd-block': errors.valid_for,
                      'd-none': !errors.valid_for
                    })}
                  >
                    {errors.valid_for && errors.valid_for}
                  </div>
                </div>
              </Form.Group>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button type="submit">Aggiungi</Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

CreateBonusMalusModal.propTypes = {
  scoreType: PropTypes.oneOf(['bonus', 'malus']).isRequired,
  playerType: PropTypes.oneOf(['students', 'teachers']).isRequired,
  modalShow: PropTypes.bool.isRequired,
  setModalShow: PropTypes.func.isRequired
};

export default CreateBonusMalusModal;
